import {Component} from "react";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import * as EmailValidator from "email-validator";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import Lbl from "../../../../components/Label/Lbl";
import LabelDropdown from "../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {Button, Icon, Input, Form, Checkbox} from "semantic-ui-react";
import * as actionCreator from "../../../../store/Action/index";
import {connect} from "react-redux";
import React from "react";
import apiConfig from "../../../../axios/axios_api_services";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 8/21/19
 * Time: 1:39 PM
 */
class App extends Component {
  state = {
    completeCorporateAdmin: null,
    corporates_list: [], email: "", name: "", username: "", password: "", corporateId: "", validatePassword: false,status:true
  };

  handleCorporateChange = (e, {value}) => {
    this.setState({
      corporateId: value
    });
  };

  handleChange = name => event => {
    let value = event.target.value;

    if (name === "password") {
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }

  };

  getAllCorporate = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            corporates_list: response.data.corporateList
          })
        } else {
          this.setState({
            corporates_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllCorporate()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };
  createSysAdmin = () => {

    const {email, name, username, corporateId} = this.state;
    if (email.trim() === "" || name.trim() === "" || username.trim() === "") {
      common.notifyMessage("Please enter all required fields");
    } else {
      let validateEmail = EmailValidator.validate(email);
      if (validateEmail) {
        if (this.state.validatePassword) {
          swal({
            title: "Do you want to create system admin?",
            icon: are_you_sure_icon,
            closeOnClickOutside: false,
            buttons: {
              cancel: 'Cancel',
              dangerMode: {
                text: "Yes",
                value: "action",
                className: "okay-btn"
              }
            },
          })
            .then((value) => {
              switch (value) {
                case "action":
                  this.sendToBackend();
                  break;
                default:
              }
            });
        } else {
          common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS");
        }
      } else {
        common.notifyMessage("Please enter valid email address");
      }
    }
  };
  sendToBackend = () => {
    const {email, name, username, corporateId, password,status} = this.state;
    const obj = {
      "userName": username,
      "password": password,
      "fullName": name,
      "email": email,
      "status": status ? 1:0,
      "userRoles": "SYS_ADMIN",
      "branchId": []
    };

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.put(apiConfig.SYSTEM_ADMIN, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("System admin successfully created - (" + username + ")", 0);
          this.clearFeilds()
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });

  };
  clearFeilds = () => {
    this.setState({
      email: "", name: "", username: "", password: "", validatePassword: false
    })
  };

  componentDidMount() {
    this.getAllCorporate();
  }

  render() {
    let corporates_list = this.state.corporates_list;
    let corporates_options = [];
    if (corporates_list.length !== 0) {
      corporates_list.map((cor, index) => {
        const obj = {
          key: index,
          text: cor.corporateName,
          value: cor.corporateId,
          // image: {avatar: true, src: cor.photoPath},
        };
        corporates_options.push(obj)
      })
    }

    return (
      <div>
        <Row>
          <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
            <Card className={this.state.completeCorporateAdmin ? "border-danger" : null}>
              <CardHeader>
                System Admin Detail
              </CardHeader>
              <CardBody>

                <Form>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Email"}
                      placeholder={"Email"}
                      value={this.state.email}
                      onChange={this.handleChange('email')}
                    />

                  </Form.Group>

                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Full Name"}
                      placeholder={"Full name"}
                      value={this.state.name}
                      onChange={this.handleChange('name')}
                    />
                  </Form.Group>
                </Form>

              </CardBody>
            </Card>
          </Col>

          <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
            <Card className={this.state.completeCorporateAdmin ? "border-danger" : null}>
              <CardHeader>
                Credentials
              </CardHeader>
              <CardBody>

                <Form>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Username"}
                      placeholder={"Username"}
                      value={this.state.username}
                      onChange={this.handleChange('username')}
                    />

                  </Form.Group>

                  <Col className={"none-padding"} lg={12}>
                    <Lbl required>Password</Lbl>
                    <Input id={"password-field"} type={"password"}
                           onChange={this.handleChange('password')}
                           value={this.state.password}
                           style={{width: '100%'}}
                           icon={<Icon onMouseUp={() => this.viewPassword(false)}
                                       onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                           placeholder='Password'/>
                  </Col>
                  <br/>
                  <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                            checked={this.state.status} onChange={()=>this.setState({ status: !this.state.status })} toggle
                            label={this.state.status ? 'Active' : 'Inactive'}/>
                </Form>

              </CardBody>
            </Card>
          </Col>

          <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
            <Button className="px-5" onClick={this.createSysAdmin}>Create System Admin</Button>
          </Col>

        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
